import { render } from "./ChatFileAttachment.vue?vue&type=template&id=52f5c666&scoped=true&ts=true"
import script from "./ChatFileAttachment.vue?vue&type=script&lang=ts"
export * from "./ChatFileAttachment.vue?vue&type=script&lang=ts"

import "./ChatFileAttachment.vue?vue&type=style&index=0&id=52f5c666&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f5c666"]])

export default __exports__